export enum MealOptionsName {
  AllBreakfastOptions = 'allbreakfastoptions',
  MustIncludeDinner = 'mustincludedinner',
}
